<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="工资表单号、名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--发薪日期--"
          end-placeholder="--发薪日期--"
          style="width: 400px"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
        <el-date-picker
          v-model="state.params.month"
          type="month"
          placeholder="薪资所属期"
          format="YYYY年M月"
          value-format="YYYY-MM"
        />
        <el-date-picker
          v-model="state.params.tax_month"
          type="month"
          placeholder="税款所属期"
          format="YYYY年M月"
          value-format="YYYY-MM"
        />
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="0">操作中</el-radio-button>
          <el-radio-button :value="1">已完成</el-radio-button>
        </el-radio-group>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="发薪方式" width="120">
          <template #default="{ row }">
            <c_status arrName="salaryrecord_type" :value="row.type" />
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template #default="{ row }">
            <c_status arrName="salaryrecord_status" :value="row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="单号" :width="160" />
        <el-table-column prop="name" label="名称" :min-width="200" />
        <el-table-column label="扣缴义务人" :min-width="200">
          <template #default="{ row }">
            <div
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :width="140"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="month"
          label="薪资所属期"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="money"
          label="发放总额"
          :formatter="$tab_MoneyFormat"
          :width="140"
        />
        <el-table-column
          prop="employee_num"
          label="发放数量"
          :formatter="$tab_NumberFormat"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="payed_num"
          label="已发放"
          :formatter="$tab_NumberFormat"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="unpayed_num"
          label="未发放"
          :formatter="$tab_NumberFormat"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="failure_num"
          label="发放失败"
          :formatter="$tab_NumberFormat"
          :width="120"
          align="center"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryRecordDetail',
                  title: '发薪单详情-' + row.id,
                  refresh: true,
                  data: {
                    id: row.id,
                    search,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customermine_salaryrecord_list } from "@/http/customer";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    customer_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      customermine_salaryrecord_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.Order = column.sortable;
        state.params.Asc = column.order === "ascending";
      } else {
        const params = new InitFormData().params;
        state.params.Order = params.Order;
        state.params.Asc = params.Asc;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };
    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
